<template>
  <div class="inte-cart w">
    <div class="cart-header">
      <h2>积分购物车</h2>
      <el-button type="danger" class="back-cart"  size="mini" @click="goBack">返回积分商城</el-button> 
      <!-- <span class="back-cart" @click="goBack">返回积分商城</span> -->
    </div>
    
    <div class="cart-content">
      <el-table
        :data="cartItems"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        ref="table"
        center
      >
        <el-table-column type="selection" width="55" ></el-table-column>
        
        <el-table-column prop="index" label="序号" width="60" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        
        <el-table-column prop="picture" label="商品图片" width="120" align="center">
          <template slot-scope="scope">
            <HnwOssImg  :src="scope.row.picture" :width="78" ></HnwOssImg>
            <!-- <img :src="scope.row.picture" class="product-image" /> -->
          </template>
        </el-table-column>
        
        <el-table-column prop="parts_name" label="礼品名称" min-width="150" align="center"></el-table-column>
        
        <el-table-column prop="stock" label="库存" width="80" align="center"></el-table-column>
        
        <el-table-column prop="quantity" label="数量" width="160" align="center">
          <template slot-scope="scope">
            <el-input-number 
              v-model="scope.row.quantity" 
              :min="1" 
              :max="Number(scope.row.stock)"
              @change="handleQuantityChange(scope.row)"
              size="small"
            ></el-input-number>
          </template>
        </el-table-column>
        
        <el-table-column prop="price" label="商品单价" width="100" align="center"></el-table-column>
        <el-table-column prop="member_name" label="操作员" width="100" align="center"></el-table-column>
        
        <el-table-column prop="subtotal" label="积分小计" width="100" align="center">
          <template slot-scope="scope">
            {{ scope.row.price * scope.row.quantity }}
          </template>
        </el-table-column>
        
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="deleteItem(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <div class="cart-footer">
        <div class="footer-left">
          <el-checkbox v-model="selectAll" @change="handleSelectAll">全选</el-checkbox>
          <el-button type="danger" @click="deleteSelected" :disabled="selectedItems.length === 0">删除选中</el-button>
        </div>
        
        <div class="footer-right">
          <div class="total-points">
            已选择 {{ selectedItems.length }} 件商品，总价：<span class="points-number">{{ totalPoints }}</span> 积分
          </div>
          <el-button type="primary" @click="submitCart" :disabled="selectedItems.length === 0">去提交</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cartItems: [],
      selectedItems: [],
      selectAll: false
    };
  },
  
  computed: {
    totalPoints() {
      return this.selectedItems.reduce((total, item) => {
        return total + (item.price * item.quantity);
      }, 0);
    }
  },
  
  async created() {
    await this.loadCart();
  },
  
  methods: {
    // 加载购物车数据
    async loadCart() {
      try {
        const res = await this.$api.getIntegralCart({
          is_sh: this.$store.state.is_sh
        });
        if (res && res.db) {
          console.log(res.db);
          // 初始化 originalQuantity 字段
          const cartItems = res.db.map(item => {
            // 确保 quantity 是有效数字
            const quantity = isNaN(item.quantity) || item.quantity === null || item.quantity === undefined ? 1 : Number(item.quantity);
            return {
              ...item,
              quantity: quantity,
              originalQuantity: quantity
            };
          });
          this.cartItems = cartItems;
        }
      } catch (error) {
        console.error('加载购物车失败:', error);
        this.$warMsg('加载购物车失败');
      }
    },
    
    // 处理选择变化
    handleSelectionChange(selection) {
      this.selectedItems = selection;
      this.selectAll = selection.length === this.cartItems.length && this.cartItems.length > 0;
    },
    
    // 全选/取消全选
    handleSelectAll(val) {
      if (val) {
        this.$nextTick(() => {
          this.cartItems.forEach(item => {
            this.$refs.table.toggleRowSelection(item, true);
          });
        });
      } else {
        this.$refs.table.clearSelection();
      }
    },
    
    // 处理数量变化
    handleQuantityChange(item) {
      // 确保 originalQuantity 存在
      if (item.originalQuantity === undefined || item.originalQuantity === null) {
        this.$set(item, "originalQuantity", item.quantity);
      }
      
      // 检查 quantity 是否为有效数字，如果不是则设置为1
      if (isNaN(item.quantity) || item.quantity === null || item.quantity === undefined || item.quantity <= 0) {
        this.$nextTick(() => {
          this.$set(item, "quantity", 1);
        });
        return;
      }
      
      // 计算数量差异
      const diff = item.quantity - item.originalQuantity;
      
      // 如果数量有变化，则调用接口修改
      if (diff !== 0) {
        this.updateCartItem(item, diff);
      }
    },
    
    // 修改购物车项（使用加入购物车接口）
    async updateCartItem(item, diff) {
      try {
        // 检查 diff 是否为有效数字
        if (isNaN(diff) || diff === null || diff === undefined) {
          this.$warMsg('数量修改异常');
          // 恢复原来的数量
          item.quantity = item.originalQuantity;
          return;
        }
        
        // 使用加入购物车接口，传递数量差异
        // 正数表示增加，负数表示减少
        const cartData = {
          parts_id: item.parts_id,
          quantity: diff
        };
        
        const res = await this.$api.addIntegralCart(cartData);
        
        if (res) {
          // 修改本地数据
          item.originalQuantity = item.quantity;
          item.subtotal = item.price * item.quantity;
          this.$suMsg('修改成功');
        } else {
          // 如果失败，恢复原来的数量
          item.quantity = item.originalQuantity;
          this.$warMsg('修改失败');
        }
      } catch (error) {
        // 如果失败，恢复原来的数量
        item.quantity = item.originalQuantity;
        console.error('修改购物车项失败:', error);
        this.$warMsg('修改购物车项失败');
      }
    },
    
    // 删除单项
    async deleteItem(item) {
      try {
        await this.$confirm('确定要删除该商品吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        
        const res = await this.$api.delIntegralCart({ id: item.id });
        
        if (res ) {
          this.$suMsg('删除成功');
          // 从列表中移除
          const index = this.cartItems.findIndex(cartItem => cartItem.id === item.id);
          if (index > -1) {
            this.cartItems.splice(index, 1);
          }
          // 修改选中项
          this.selectedItems = this.selectedItems.filter(selectedItem => selectedItem.id !== item.id);
          // 修改全选状态
          this.selectAll = this.selectedItems.length === this.cartItems.length && this.cartItems.length > 0;
        } else {
          this.$warMsg('删除失败');
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除商品失败:', error);
          this.$warMsg('删除商品失败');
        }
      }
    },
    
    // 批量删除选中项
    async deleteSelected() {
      if (this.selectedItems.length === 0) return;
      
      try {
        await this.$confirm(`确定要删除选中的 ${this.selectedItems.length} 件商品吗?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        
        // 拼接ID
        const ids = this.selectedItems.map(item => item.id).join(',');
        const res = await this.$api.delIntegralCart({ id: ids });
        
        if (res ) {
          this.$suMsg('删除成功');
          // 从列表中移除
          const selectedIds = this.selectedItems.map(item => item.id);
          this.cartItems = this.cartItems.filter(item => !selectedIds.includes(item.id));
          // 清空选中项
          this.selectedItems = [];
          this.selectAll = false;
        } else {
          this.$warMsg('删除失败');
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除商品失败:', error);
          this.$warMsg('删除商品失败');
        }
      }
    },
    
    // 提交购物车
    submitCart() {
      // 检查是否选择了商品
      if (this.selectedItems.length === 0) {
        this.$message.warning('请至少选择一件商品');
        return;
      }
      
      // 计算选中商品的总积分
      const totalPoints = this.selectedItems.reduce((total, item) => {
        return total + (item.price * item.quantity);
      }, 0);
      
      // 检查积分余额
      const integralBalance = this.$store.state.integral_num || 0;
      
      if (totalPoints > integralBalance) {
        this.$message.warning(`积分不足，当前积分余额：${integralBalance}，所需积分：${totalPoints}`);
        return;
      }
      
      // 将选中的购物车数据存储到本地存储空间
      localStorage.setItem('selectedCartItems', JSON.stringify(this.selectedItems));
      
      // 跳转到提交订单页面，传递标识值
      this.$router.push(`/integral/suborder/cart/multiple`);
    },
    
    goBack() {
      this.$router.push('/integral');
    }
  }
};
</script>

<style lang="scss" scoped>
.inte-cart {
  padding: 20px;
  background: #fff;
  
  .cart-header {
    border-bottom: 1px solid #eee;
    padding-bottom: 15px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    h2 {
      margin: 0;
      color: #333;
    }
    
    .back-cart {
      // color: #10317C;
      cursor: pointer;
      font-size: 16px;
      font-weight: 700;
      margin-left: 10px;
    }
  }
  
  .product-image {
    width: 80px;
    height: 80px;
    object-fit: cover;
  }
  
  .cart-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    padding: 20px 14px;
    border-top: 1px solid #eee;
    
    .footer-left {
      display: flex;
      align-items: center;
      
      .el-checkbox {
        margin-right: 20px;
      }
    }
    
    .footer-right {
      display: flex;
      align-items: center;
      
      .total-points {
        margin-right: 20px;
        font-size: 16px;
        
        .points-number {
          color: #ff6600;
          font-weight: bold;
          font-size: 18px;
        }
      }
    }
  }
}
</style>